import axiosIns from '../../../xaxios';
import { obtenerUrlAPIComisiones } from '../utils/funciones';

export default {
  async create(datos) {
    return await axiosIns.post(obtenerUrlAPIComisiones('tipos-documentos-persona'), datos);
  },
  async findAll() {
    return await axiosIns.get(obtenerUrlAPIComisiones('tipos-documentos-persona'));
  },
  async findOne(id) {
    return await axiosIns.get(obtenerUrlAPIComisiones(`tipos-documentos-persona/${id}`));
  },
  async update(id, datos) {
    return await axiosIns.patch(obtenerUrlAPIComisiones(`tipos-documentos-persona/${id}`), datos);
  },
  async remove(id) {
    return await axiosIns.delete(obtenerUrlAPIComisiones(`tipos-documentos-persona/${id}`));
  },
};
